export const PROXTRA_DOLLARS_MESSAGE = {
  title: 'Pro Xtra Dollars',
  message:
    'Pro Xtra Dollars are digital reward cards that can be applied to online and in-store purchases. You can view these purchases in your Purchase History. Pro Xtra Dollars spend does not accrue towards rebate programs.',
};
export const GIFT_CARDS_MESSAGE = {
  title: 'Keep Your Gift Card Details',
  message:
    "At this time, you can't select saved gift cards as a payment method in checkout, but you can enter them manually. Keep your gift card details to checkout in store or online. You can view all purchases made with a saved gift card in your account and receive any associated rebates.",
};

export const GIFT_CARD_BACKSIDE_IMG_URL =
  'https://secure2.homedepot.com/hdus/en_US/DTCCOM/common/giftcard/Images/WhereDoIFindPIN-newCardV4-withoutTitle.jpg';
